module.exports = __webpack_public_path__ + "static/media/aeronave.38af6acf.png";